import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import tokens from '../../styles/tokens.css?raw';

// tailwind-merge must be taught our scales: a group missing here is sorted into colours, and `text-caps text-faint` silently keeps only the last.
const namesOf = (namespace: string): string[] => [
  ...new Set(
    [...tokens.matchAll(new RegExp(`--${namespace}-([a-zA-Z0-9-]+?)\\s*:`, 'g'))]
      .map((match) => match[1])
      .filter((name) => !name.includes('--')),
  ),
];

const merge = extendTailwindMerge({
  override: {
    classGroups: {
      'font-size': [{ text: namesOf('text') }],
      'text-color': [{ text: namesOf('color') }],
      'bg-color': [{ bg: namesOf('color') }],
      'border-color': [{ border: namesOf('color') }],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => merge(clsx(inputs));

export const POPOVER_MOTION = [
  'data-[state=open]:data-[side=bottom]:animate-[hp-pop-in_120ms_ease-out]',
  'data-[state=open]:data-[side=top]:animate-[hp-pop-in-up_120ms_ease-out]',
  'data-[state=closed]:animate-[hp-fade-out_90ms_ease-in]',
].join(' ');
